import { Mail } from "lucide-react";
import { clasesBoton } from "../foundational/Button";
import WhatsAppIcon from "../icons/WhatsAppIcon";
import { CONTACTO_EMAIL, enlaceWhatsApp, whatsappDisponible } from "../../lib/contacto";
import { registrarClicContacto } from "../../lib/contactoClic";

// Las piezas de contacto que comparten Contacto, Para instituciones y la
// portada. Son ENLACES (no botones): abren WhatsApp o el correo, y así quien
// quiera puede copiarlos o abrirlos en otra pestaña. Cada clic se registra con
// su canal y su ubicación (lib/contactoClic.js), nunca con el número ni el
// mensaje.

const ENLACE_TEXTO =
  "inline-flex min-h-[44px] items-center gap-1.5 rounded-tk-sm text-small font-semibold text-accent dark:text-accent-light hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40";

// Abre la conversación con Sebastián con el mensaje del motivo ya escrito. La
// persona lo puede editar y decide cuándo enviarlo: wa.me no envía nada solo.
// Sin el kill-switch no dibuja nada (queda el correo, que va al lado).
export function BotonWhatsApp({ motivo = "general", ubicacion, conSesion = false, variant = "primary", children, className = "" }) {
  if (!whatsappDisponible()) return null;
  return (
    <a
      href={enlaceWhatsApp(motivo)}
      target="_blank"
      rel="noopener noreferrer"
      data-canal="whatsapp"
      onClick={() => registrarClicContacto("whatsapp", ubicacion, { conSesion })}
      className={`${clasesBoton({ variant, size: "lg" })} min-h-[44px] active:scale-[0.98] ${className}`}
    >
      <WhatsAppIcon className="h-5 w-5 flex-shrink-0" />
      <span>{children}</span>
    </a>
  );
}

export function EnlaceCorreo({ ubicacion, conSesion = false, children, className = "" }) {
  return (
    <a
      href={`mailto:${CONTACTO_EMAIL}`}
      data-canal="correo"
      onClick={() => registrarClicContacto("correo", ubicacion, { conSesion })}
      className={`${ENLACE_TEXTO} ${className}`}
    >
      <Mail aria-hidden="true" size={16} strokeWidth={1.8} className="flex-shrink-0" />
      <span>{children || CONTACTO_EMAIL}</span>
    </a>
  );
}

// La invitación a contactarnos de una institución, igual en la portada,
// Contacto y Para instituciones. Sebastián, 2026-10-30, tras "Conversemos" y
// "Escríbenos": "Tampoco así. Si te interesa, puedes contactarnos! Algo así".
// Invita, no ordena: la frase va primero y los botones solo dicen el canal.
// `fila` alinea los botones como el bloque donde va.
export function InvitacionInstitucional({ ubicacion, conSesion = false, fila = "", className = "" }) {
  return (
    <div className={className}>
      <p className="text-body font-medium text-ink">Si te interesa, puedes contactarnos.</p>
      <div className={`mt-3 flex flex-wrap items-center gap-x-5 gap-y-2 ${fila}`}>
        <BotonWhatsApp motivo="institucional" ubicacion={ubicacion} conSesion={conSesion}>Por WhatsApp</BotonWhatsApp>
        <EnlaceCorreo ubicacion={ubicacion} conSesion={conSesion} />
      </div>
    </div>
  );
}

// WhatsApp y el correo son canales que MiPAE no controla: aquí no entran datos
// de pacientes (el motivo del retiro del 2026-10-17). Se dice una vez, sin
// retar, donde está el botón.
export function AvisoSinPacientes({ className = "" }) {
  return (
    <p className={`text-small leading-relaxed text-ink-subtle dark:text-ink-muted ${className}`}>
      {whatsappDisponible() ? "Por WhatsApp o por correo" : "Por correo"}, no envíes nombres, RUT, fotos ni otros datos de pacientes.
    </p>
  );
}

export { ENLACE_TEXTO };
